/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { Link } from "react-router-dom";

import type { FC } from "react";

type Props = {
  to: string;
  icon: JSX.Element;
  menuName: string;
  onClick?: () => void;
};

export const AccountMenuItem: FC<Props> = ({ to, icon, menuName, onClick }) => {
  const classes = styles();

  return (
    <li css={classes.root}>
      <Link css={classes.link} to={to} onClick={onClick}>
        <span css={classes.content}>
          <span css={classes.label}>
            {icon}
            <span>{menuName}</span>
          </span>

          <NavigateNextIcon css={classes.nextIcon} aria-hidden="true" />
        </span>
      </Link>
    </li>
  );
};

const styles = () => ({
  root: css`
    border-bottom: 1px solid #e6e5e6;
  `,
  link: css`
    display: block;
  `,
  content: css`
    display: grid;
    grid-template-columns: minmax(0, 1fr) max-content;
    align-items: center;
    gap: 8px;
    padding: 12px 8px;
    margin: 0 auto;
  `,
  label: css`
    display: grid;
    grid-template-columns: max-content minmax(0, 1fr);
    align-items: center;
    gap: 8px;
    color: #38444b;
    font-size: 14px;
  `,
  nextIcon: css`
    color: #38444b;
  `,
});
